export const riskAnalysisStatus = {
    draft : "draft",
    filled : "filled",
    analysed : "analysed",
    decided : "decided",
    closed : "closed" 
}